import {Component, Input, OnInit} from '@angular/core';
import {PriceRobotFilter} from "../services/price-robot-filter";
import {PriceRobotRulesService} from "../services/price-robot-rules.service";
import {PriceRobotMessageService} from "../services/price-robot-message.service";
import {ShipmentRoute} from "../services/shipment-route";
import {PriceRobotRule} from "../services/price-robot-rule";

@Component({
    selector: 'app-price-robot-rules-list',
    templateUrl: './price-robot-rules-list.component.html',
    styleUrls: ['./price-robot-rules-list.component.scss']
})
export class PriceRobotRulesListComponent implements OnInit {

    @Input() public rules: PriceRobotRule[];
    @Input() public embedded: boolean;

//    public rules: any;
    public inactiveRules: any;
    public filter: PriceRobotFilter = new PriceRobotFilter();
    public loading: boolean = false;

    // Options are set via setSortingOptions() in loadData
    sortableOptions: any = {};

    constructor(private priceRobotRulesService: PriceRobotRulesService,
                private priceRobotMessageService: PriceRobotMessageService) {
    }

    ngOnInit(): void {
        if (!this.embedded) {
            this.loadData();
        }
    }

    loadData() {
        this.loading = true;
        this.priceRobotRulesService.index().subscribe(result => {
            this.loading = false;

            this.setSortingOptions();

            let data: any = result;

            this.rules = data.rules;

            this.sortRules();
        }, error => {
            this.priceRobotMessageService.handleError(error);
        })
    }

    sortRules() {
        let inactiveRules: any = [];
        let rules: any = [];
        let active_start: any;
        let active_end: any;
        this.rules.forEach(function (rule: any) {
            if (rule.active_start !== null) {
                active_start = new Date(rule.active_start);
                active_start.setHours(0, 0, 0, 0);
            }
            if (rule.active_end !== null) {
                active_end = new Date(rule.active_end);
                active_end.setHours(0, 0, 0, 0);
            }
            let date = new Date();
            date.setHours(0, 0, 0, 0);
            if (active_end < date || active_start > date || !rule.is_active) {
                inactiveRules.push(rule);
            } else {
                rules.push(rule);
            }
        })
        this.rules = rules;
        this.inactiveRules = inactiveRules;
    }

    saveSorting() {
        this.loading = true;

        this.setSortingOptions(true);

        let rules = [];
        let i = 0;

        for (let rule of this.rules) {
            rules.push({
                id: rule.id,
                sorting: i
            });

            i++;
        }

        this.priceRobotRulesService.editMany(rules).subscribe(_ => {
            this.loadData();
        });
    }

    setSortingOptions(disabled = false) {
        // We need to replace the entire object to trigger the options change, just changing a property will not do
        this.sortableOptions = {
            delay: 0,
            animation: 150,
            disabled: disabled,
            onUpdate: () => {
                this.saveSorting();
            }
        };
    }
}
